import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipStationSuppliesLinkText: {
    id: 'l+XYjq',
    defaultMessage: 'ShipStation Supplies',
    description: 'Link text for ShipStation Supplies store',
  },
  homeTitle: {
    id: 'f5pPU2',
    defaultMessage: 'Stock Up on Supplies',
    description: 'Title for supplies section on home page',
  },
  homeSubtext: {
    id: 'iMKMq4',
    defaultMessage: 'Shop for ShipStation Connect-compatible printers and labels at the {link} store.',
    description: 'Subtext for supplies section on home page',
  },
  settingsTitle: {
    id: 'W5PTh0',
    defaultMessage: 'Shipping and Printing Supplies',
    description: 'Title for supplies section on settings page',
  },
  settingsSubtext: {
    id: 'CQXMxM',
    defaultMessage:
      'Shop the {link} store for all your shipping essentials, including label printers, shipping scales, and packing materials.',
    description: 'Subtext for supplies section on settings page',
  },
  settingsPackagesTitle: {
    id: 'pbV496',
    defaultMessage: 'Need More Labels?',
    description: 'Title for supplies section on settings packages page',
  },
  settingsPackagesSubtext: {
    id: 'oTAxgz',
    defaultMessage: 'Shop for label sheets and rolls at the {link} store.',
    description: 'Subtext for supplies section on settings packages page',
  },
  settingsPrintingConnectTitle: {
    id: '/cbvFM',
    defaultMessage: 'Need Shipping Hardware or Labels?',
    description: 'Title for supplies section on settings printing connect page',
  },
  settingsPrintingConnectSubtext: {
    id: 'SnRPCN',
    defaultMessage: 'Shop for ShipStation Connect-compatible printers and labels at the {link} store.',
    description: 'Subtext for supplies section on settings printing connect page',
  },
  settingsPrintingSetupTitle: {
    id: 'cRvar9',
    defaultMessage: 'Need More Labels?',
    description: 'Title for supplies section on settings printing setup page',
  },
  settingsPrintingSetupSubtext: {
    id: '8u4BCx',
    defaultMessage: 'Shop for label sheets and rolls at the {link} store.',
    description: 'Subtext for supplies section on settings printing setup page',
  },
  checkoutError: {
    id: 'fI/4Xq',
    defaultMessage: 'Unable to complete checkout. Please try again.',
    description: 'Error message when checkout fails',
  },
  popupBlockedError: {
    id: 'MfNLo7',
    defaultMessage: 'Popup was blocked. Please allow popups for this site and try again.',
    description: 'Error message when popup blocker prevents checkout window from opening',
  },
  suppliesPageTitle: {
    id: 'iymJ9w',
    defaultMessage: 'Supplies',
    description: 'Placeholder title for supplies page (not used in SuppliesCardContainer)',
  },
  suppliesPageSubtext: {
    id: 'R3zE05',
    defaultMessage: 'Shop supplies',
    description: 'Placeholder subtext for supplies page (not used in SuppliesCardContainer)',
  },
});
